import React from "react";
import { RESOURCE_NAME } from "common/authorization";
import { FEATURE_FLAG_NAME } from "common/constants";
import { AuthContext } from "../../Authorization/AuthContext";
import { MenuItems, SubTabMenu } from "../SubTabMenu";
import Disclaimers from "./Disclaimers";
import General from "./General";
import ObjectGroups from "./ObjectGroups";
import PropertyData from "./PropertyData";
import PublicWebsite from "./PublicWebsite";
import Records from "./Records";
import Security from "./Security";
import Warnings from "./Warnings/WarningSettings";

export const Account = () => {
  const { admin, account, authorized, isFeatureEnabled } =
    React.useContext(AuthContext);
  const canUpdateAccountInformation = authorized({
    resource: RESOURCE_NAME.ACCOUNT,
    permission: "update",
  });
  const canManageSubmissionTypes = authorized({
    resource: RESOURCE_NAME.SUBMISSION_TYPE,
    permission: "create",
  });

  const menuItems: MenuItems = [
    {
      name: "General",
      path: "/general",
      component: General,
    },
    {
      name: "Security",
      path: "/security",
      component: Security,
    },
    {
      name: "Public website",
      path: "/public-website",
      hide: !canUpdateAccountInformation || !account?.publicPortal?.enabled,
      restrict: !canUpdateAccountInformation,
      component: PublicWebsite,
    },
    {
      name: "Property data",
      path: "/property-data",
      hide: !admin,
      restrict: !admin,
      component: PropertyData,
    },
    {
      name: "Records",
      path: "/records",
      hide:
        !admin &&
        !(
          canManageSubmissionTypes &&
          isFeatureEnabled(FEATURE_FLAG_NAME.SUBMISSION_BUILDER_USER_ACCESS)
        ),
      restrict:
        !admin &&
        !(
          canManageSubmissionTypes &&
          isFeatureEnabled(FEATURE_FLAG_NAME.SUBMISSION_BUILDER_USER_ACCESS)
        ),
      component: Records,
    },
    {
      name: "Objects",
      path: "/objects",
      hide: !admin,
      restrict: !admin,
      component: ObjectGroups,
    },
    { name: "Warnings", path: "/warnings", component: Warnings },
    {
      name: "Disclaimers",
      path: "/disclaimers",
      hide: !admin,
      restrict: !admin,
      component: Disclaimers,
    },
  ];

  return <SubTabMenu menuItems={menuItems} />;
};
